import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  HStack,
  VStack, // Import VStack
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Text, // Import Text
  StackDivider, // Import StackDivider สำหรับเส้นกั้น
  Flex,
} from "@chakra-ui/react";
import { useAuth } from "../context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// --- Import ไอคอนที่คุณเลือกใช้ ---
import {
  faHome, faSyringe, faBook, faChartBar, faWarehouse, faDatabase,
  faCubes, faTruck, faRightLeft, faPenToSquare, faFileInvoice,
  faUsers, faFileLines, faChevronDown, faClipboardList, faDollarSign,
  faShieldHalved, faMagnifyingGlassChart, faBoxesPacking,
  faLineChart,
  faWrench,
  faBasketShopping,
  faShieldVirus,
  faChartPie
} from "@fortawesome/free-solid-svg-icons";


const TopMenu = () => {
  const { sessionId, profile } = useAuth();
  const [isStaff, setIsStaff] = useState(false);
  const navigate = useNavigate();

  // ปรับขนาด font ของ label ใต้ icon
  const labelFontSize = "clamp(0.5rem, 2vw, .95rem)";
  const subMenuFontSize = "clamp(0.5rem, 2vw, .85rem)";

  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    if (!profile.OfficeID) {
      setIsStaff(false);
      setMenuItems([
        { label: "หน้าแรก", path: "/home", icon: faHome },
        { label: "สั่งจองวัคซีน", path: "/vaccinereservationlist", icon: faSyringe },
        { label: "จุดจำหน่ายวัคซีน", path: "/distributionpoint", icon: faWarehouse },
        {
          label: "แบบสอบถาม",
          icon: faBook,
          path: "/generallist",
          subMenu: [
            { label: "แบบสำรวจความพึงพอใจในผลิตภัณฑ์", path: "/questionnaire"},
            { label: "แบบประเมินผลการใช้วัคซีน", path: "/usageevalquestionnaire"},
          ],
        },
        {
          label: "สาระน่ารู้",
          icon: faBook,
          path: "/generallist",
          subMenu: [
            { label: "การใช้งานระบบสั่งจองวัคซีนออนไลน์", path: "/usermanual" },
            { label: "ข้อมูลโรคในสัตว์", path: "/diseaseinfo" },
            { label: "ข้อมูลวัคซีนปศุสัตว์", path: "/vaccineinfo" },
            { label: "สถานการณ์การเกิดโรคระบาดที่เกิดขึ้นล่าสุด", path: "/webcontentepidemic" },
            { label: "รายงานข้อมูลประวัติย้อนหลังในการเกิดโรคระบาด", path: "/animalepidemicreport" },
            //{ label: "ภาพรวมการใช้วัคซีน", path: "/vaccineusageoverview" },
            { label: "ข้อมูลจำนวนปศุสัตว์แยกตามพื้นที่", path: "/livestockamountoverview" },
          ],
        },
      ]);
    } else {
      setIsStaff(true);
      // แยกเมนูตามประเภทหน่วยงาน
      switch (profile.OfficeType) {
        case "ปศข.":
          setMenuItems([
            { label: "หน้าแรก", path: "/dashboard", icon: faHome },
            {
              label: "จัดการคลังวัคซีน", icon: faWarehouse,
              path: "/officersvlist",
              subMenu: [
                { label: "เบิกวัคซีน", path: "/vaccinerequisitionlist" },
                { label: "รับวัคซีนเข้าคลัง", path: "/vaccinereceivelist" },
                //{ label: "รับวัคซีนเข้าคลัง (งบป้องกัน)", path: "/vaccinepreventionreceivelist" },
                { label: "อนุมัติจ่ายวัคซีน ", path: "/vaccinerequisitionrequestlist" },
                { label: "ขอคืนวัคซีน", path: "/vaccinereturnlist" },
                { label: "อนุมัติคืนวัคซีน", path: "/vaccinereturnrequestlist" },
                { label: "ปรับยอดวัคซีน", path: "/vaccineadjustmentlist" },
              ],
            },
            {
              label: "ประเมินความต้องการ", icon: faClipboardList,
              path: "/officersvlist",
              subMenu: [
                { label: "งบจำหน่าย", path: "/vaccineestimatedistributionlist" },
              ],
            },
            {
              label: "จัดการข้อมูลหลัก", icon: faDatabase,
              subMenu: [
                { label: "ที่ตั้งคลังวัคซีน", path: "/masterwarehouse" },
                { label: "ข้อมูลวัคซีน", path: "/mastervaccine" },
                //{ label: "ประเภทปศุสัตว์", path: "/masterlivestocktype" },
                { label: "หน่วยงาน", path: "/masterdldoffice" },
              ],
            },
            {
              label: "รายงาน", icon: faChartBar,
              path: "/officersvlist",
              subMenu: [
                { label: "รายงานวัคซีนคงคลัง", path: "/vaccineinventoryreport" },
                { label: "รายงานวัคซีนคงคลัง (ตาม Lot การผลิต)", path: "/vaccineinventorywithlotreport" },
                { label: "รายงานวัคซีนคงคลัง (ย้อนหลัง)", path: "/vaccineinventorybydatereport" },
                { label: "รายงานการขอเบิกวัคซีน", path: "/vaccinerequisitionreport" },
                { label: "รายงานสรุปเงินทุนฯ (ผช.37) ระดับปศุสัตว์เขต", path: "/vaccinerequisitionfundingsummary" },
                { label: "รายงานสรุปเงินทุนฯ (ผช.37)", path: "/vaccinefundingmonthlysummary" },
              ],
            },
          ]);
          break;

        case "ปศจ.":
          setMenuItems([
            { label: "หน้าแรก", path: "/dashboard", icon: faHome },
            {
              label: "จองและจำหน่าย", icon: faBasketShopping,
              path: "/officersvlist",
              subMenu: [
                { label: "จำหน่ายวัคซีนเกษตรกร", path: "/vaccinesalelist" },
                { label: "การจองวัคซีนเกษตรกร", path: "/staffvaccinereservationlist" },
                //{ label: "จองวัคซีนหน่วยงาน", path: "/officersvlist" },
              ],
            },
            {
              label: "จัดการคลัง", icon: faWarehouse,
              path: "/officersvlist",
              subMenu: [
                { label: "เบิกวัคซีน", path: "/vaccinerequisitionlist" },
                { label: "รับวัคซีนเข้าคลัง", path: "/vaccinereceivelist" },
                //{ label: "รับวัคซีนเข้าคลัง (งบป้องกัน)", path: "/vaccinepreventionreceivelist" },
                { label: "ขอคืนวัคซีน", path: "/vaccinereturnlist" },
                { label: "ปรับยอดวัคซีน", path: "/vaccineadjustmentlist" },
              ],
            },
            {
              label: "จัดการข้อมูลหลัก", icon: faWrench,
              subMenu: [
                { label: "ที่ตั้งคลังวัคซีน", path: "/masterwarehouse" },
                { label: "ข้อมูลวัคซีน", path: "/mastervaccine" },
                //{ label: "ประเภทปศุสัตว์", path: "/masterlivestocktype" },
                { label: "หน่วยงาน", path: "/masterdldoffice" },
              ],
            },
            {
              label: "รายงาน", icon: faChartBar,
              path: "/officersvlist",
              subMenu: [
                { label: "รายงานวัคซีนคงคลัง", path: "/vaccineinventoryreport" },
                { label: "รายงานวัคซีนคงคลัง (ตาม Lot การผลิต)", path: "/vaccineinventorywithlotreport" },
                { label: "รายงานวัคซีนคงคลัง (ย้อนหลัง)", path: "/vaccineinventorybydatereport" },
                { label: "รายงานการจำหน่ายวัคซีน (งบจำหน่าย)", path: "/vaccinesaleorderreport" },
                { label: "รายงานสรุปรายการสั่งจองวัคซีน", path: "/vaccinereservationsummaryreport" },
                { label: "รายงานการสั่งจองวัคซีน", path: "/vaccinereservationreport" },
                { label: "รายงานสรุปเงินทุนฯ (ผช.37)", path: "/vaccinefundingmonthlysummary" },
              ],
            },
          ]);
          break;

        case "สคบ.":
          setMenuItems([
            { label: "หน้าแรก", path: "/dashboard", icon: faHome },
            {
              label: "วัคซีนงบป้องกัน", icon: faShieldVirus,
              path: "/officersvlist",
              subMenu: [
                { label: "ประเมินความต้องการ", path: "/vaccineestimatepreventionlist", },
                //{ label: "เบิกวัคซีน", path: "/vaccineprotectrequisitionlist" },
                { label: "เบิกวัคซีน", path: "/vaccinepreventionrequisitionlist" },
              ],
            },
            {
              label: "จัดการข้อมูลหลัก", icon: faDatabase,
              subMenu: [
                { label: "ที่ตั้งคลังวัคซีน", path: "/masterwarehouse" },
                { label: "ข้อมูลวัคซีน", path: "/mastervaccine" },
                //{ label: "ประเภทปศุสัตว์", path: "/masterlivestocktype" },
                { label: "หน่วยงาน", path: "/masterdldoffice" },
              ],
            },
            {
              label: "รายงาน", icon: faChartBar,
              path: "/officersvlist",
              subMenu: [
                { label: "รายงานแผนความต้องการวัคซีน (งบป้องกัน)", path: "/vaccinepestimatepreventionreport" },
              ],
            },
          ]);
          break;

        case "สทช.-จุดจำหน่าย":
          setMenuItems([
            { label: "หน้าแรก", path: "/dashboard", icon: faHome },
            {
              label: "จองและจำหน่าย", icon: faBasketShopping,
              path: "/officersvlist",
              subMenu: [
                { label: "จำหน่ายวัคซีนเกษตรกร", path: "/vaccinesalelist" },
                { label: "การจองวัคซีนเกษตรกร", path: "/staffvaccinereservationlist" },
                //{ label: "จองวัคซีนหน่วยงาน", path: "/officersvlist" },
              ],
            },
            {
              label: "จัดการคลัง", icon: faWarehouse,
              path: "/officersvlist",
              subMenu: [
                { label: "เบิกวัคซีน", path: "/vaccinerequisitionlist" },
                { label: "รับวัคซีนเข้าคลัง", path: "/vaccinereceivelist" },
              ],
            },
            {
              label: "จัดการข้อมูลหลัก", icon: faWrench,
              subMenu: [
                { label: "ที่ตั้งคลังวัคซีน", path: "/masterwarehouse" },
                { label: "ข้อมูลวัคซีน", path: "/mastervaccine" },
                //{ label: "ประเภทปศุสัตว์", path: "/masterlivestocktype" },
                { label: "หน่วยงาน", path: "/masterdldoffice" },
              ],
            },
            {
              label: "รายงาน", icon: faChartBar,
              path: "/officersvlist",
              subMenu: [
                { label: "รายงานวัคซีนคงคลัง", path: "/vaccineinventoryreport" },
                { label: "รายงานวัคซีนคงคลัง (ตาม Lot การผลิต)", path: "/vaccineinventorywithlotreport" },
                { label: "รายงานวัคซีนคงคลัง (ย้อนหลัง)", path: "/vaccineinventorybydatereport" },
                { label: "รายงานการจำหน่ายวัคซีน (งบจำหน่าย)", path: "/vaccinesaleorderreport" },
                { label: "รายงานสรุปรายการสั่งจองวัคซีน", path: "/vaccinereservationsummaryreport" },
                { label: "รายงานการสั่งจองวัคซีน", path: "/vaccinereservationreport" },
                { label: "รายงานสรุปเงินทุนฯ (ผช.37)", path: "/vaccinefundingmonthlysummary" },
              ],
            },
          ]);
          break;

        case "สทช.":
          setMenuItems([
            { label: "หน้าแรก", path: "/dashboard", icon: faHome },
            {
              label: "จัดการคลังวัคซีน", icon: faWarehouse,
              path: "/officersvlist",
              subMenu: [
                { label: "รับวัคซีนจากการผลิต", path: "/vaccineproductionreceivelist" },
                { label: "Lot การผลิตวัคซีน", path: "/mastervaccinelot" },
                //{ label: "รับวัคซีนเข้าคลัง", path: "/vaccinereceivelist" },
                //{ label: "เบิกวัคซีน", path: "/vaccinerequisitionlist" },
                { label: "อนุมัติจ่ายวัคซีน ", path: "/vaccinerequisitionrequestlist" },
                //{ label: "อนุมัติจ่ายวัคซีน (งบป้องกัน) ", path: "/vaccinepreventionrequisitionrequestlist" },
                { label: "อนุมัติคืนวัคซีน", path: "/vaccinereturnrequestlist" },
                //{ label: "โอนย้ายวัคซีน", path: "/vaccinetransfer" },
                { label: "ปรับยอดวัคซีน", path: "/vaccineadjustmentlist" },
                //{ label: "ยืนยันยอดสั่งจองวัคซีน", path: "/vaccinereservationconfirm" }
              ],
            },
            {
              label: "ประเมินความต้องการ", icon: faClipboardList,
              path: "/officersvlist",
              subMenu: [
                { label: "แผนการผลิต (ข้อมูลการสั่งผลิต)", path: "/vaccineestimateproductionlist" },
                { label: "งบจำหน่าย", path: "/vaccineestimatedistributionlist" },
                { label: "งบป้องกัน", path: "/vaccineestimatepreventionlist" },
              ],
            },
            {
              label: "ข้อมูลหลัก", icon: faDatabase, icon: faDatabase,
              subMenu: [
                { label: "ที่ตั้งคลังวัคซีน", path: "/masterwarehouse" },
                { label: "ข้อมูลวัคซีน", path: "/mastervaccine" },
                //{ label: "ประเภทปศุสัตว์", path: "/masterlivestocktype" },
                { label: "หน่วยงาน", path: "/masterdldoffice" },
                { label: "แบบสอบถาม", path: "/questionnaire-list" },
              ],
            },
            {
              label: "ระบบข้อมูลสารสนเทศ ", icon: faLineChart,
              path: "/officersvlist",
              subMenu: [
                //{ label: "รายงานแผนความต้องการวัคซีน", path: "/vaccinepreventiondemandplanreport" },
                { label: "Dashboard สถิติการเข้าใช้งานระบบ", path: "/systemusagedashboard" },
                { label: "Dashboard สถิติการเข้าถึงเว็บไซต์", path: "/websitevisitstatsdashboard" },
                { label: "Dashboard ยอดวัคซีนคงคลัง", path: "/vaccineinventorydashboard" },
                { label: "รายงานแผนความต้องการวัคซีน (งบป้องกัน)", path: "/vaccinepestimatepreventionreport" },
                { label: "รายงานแผนความต้องการวัคซีน (งบจำหน่าย)", path: "/vaccinepestimatedistributionreport" },
                { label: "รายงานการผลิตวัคซีน", path: "/vaccineproductionreport" },
                { label: "รายงานแผนการผลิตวัคซีน", path: "/vaccineproductionplanreport" },
                { label: "รายงานผลการส่งวัคซีนทดสอบ", path: "/vaccineqcresultreport" },
                { label: "รายงานการกระจายวัคซีน (งบป้องกัน)", path: "/vaccinepreventiondistributionreport" },
                { label: "รายงานการจำหน่ายวัคซีน (งบจำหน่าย)", path: "/vaccinesaleorderreport" },
                { label: "รายงานวัคซีนคงคลัง", path: "/vaccineinventoryreport" },
                { label: "รายงานวัคซีนคงคลัง (ตาม Lot การผลิต)", path: "/vaccineinventorywithlotreport" },
                { label: "รายงานวัคซีนคงคลัง (ย้อนหลัง)", path: "/vaccineinventorybydatereport" },
                { label: "รายงานการขอเบิกวัคซีน", path: "/vaccinerequisitionreport" },
                { label: "รายงานสรุปรายการสั่งจองวัคซีน", path: "/vaccinereservationsummaryreport" },
                { label: "รายงานการสั่งจองวัคซีน", path: "/vaccinereservationreport" },
                { label: "รายงานวัคซีนใกล้หมดอายุ", path: "/vaccineaboutexpirereport" },
                { label: "รายงานการขนส่งวัคซีน", path: "/vaccineshippingreport" },
                { label: "รายงานสรุปผลจากแบบสอบถาม", path: "/vaccineusagesatisfactionreport" },
                { label: "รายงานสรุปผลการเกิดโรคระบาด", path: "/animalepidemicreport" },
                { label: "รายงานสรุปผลการใช้วัคซีน", path: "/vaccineusageevaluatereport" },
                // { label: "รายงานวัคซีนคงคลังตามระดับคลัง", path: "/vaccineInventoryregionreport" },
                { label: "รายงานวัคซีนคงคลังตามระดับคลัง", path: "/vaccineinventorybywarehouselevelreport" },
                { label: "รายงานจำนวนปศุสัตว์แยกตามพื้นที่", path: "/livestockamountreport" },
                { label: "รายงานการแสดงความคิดเห็น", path: "/visitorcommentsreport" },
                { label: "รายงานการเข้าใช้งานระบบ", path: "/userloginlogreport" },
              ],
            },
          ]);
          break;

        case "SystemAdmin":
          setMenuItems([
            { label: "หน้าแรก", path: "/dashboard", icon: faHome },
            {
              label: "ผู้ใช้งานระบบ", icon: faUsers,
              path: "/officersvlist",
              subMenu: [
                { label: "ข้อมูลเจ้าหน้าที่", path: "/masterdldemployee" },
                { label: "ข้อมูลเกษตรกร", path: "/masterfarmer" },
                //{ label: "จองวัคซีนหน่วยงาน", path: "/officersvlist" },
              ],
            },
            {
              label: "จองและจำหน่าย", icon: faBasketShopping,
              path: "/officersvlist",
              subMenu: [
                { label: "จำหน่ายวัคซีนเกษตรกร", path: "/vaccinesalelist" },
                { label: "การจองวัคซีนเกษตรกร", path: "/staffvaccinereservationlist" },
                //{ label: "จองวัคซีนหน่วยงาน", path: "/officersvlist" },
              ],
            },
            {
              label: "จัดการคลังวัคซีน", icon: faWarehouse,
              path: "/officersvlist",
              subMenu: [
                { label: "รับวัคซีนจากการผลิต", path: "/vaccineproductionreceivelist" },
                { label: "Lot การผลิตวัคซีน", path: "/mastervaccinelot" },
                //{ label: "รับวัคซีนเข้าคลัง", path: "/vaccinereceivelist" },
                //{ label: "เบิกวัคซีน", path: "/vaccinerequisitionlist" },
                { label: "อนุมัติจ่ายวัคซีน ", path: "/vaccinerequisitionrequestlist" },
                { label: "อนุมัติคืนวัคซีน", path: "/vaccinereturnrequestlist" },
                //{ label: "โอนย้ายวัคซีน", path: "/vaccinetransfer" },
                { label: "ปรับยอดวัคซีน", path: "/vaccineadjustmentlist" },
                //{ label: "ยืนยันยอดสั่งจองวัคซีน", path: "/vaccinereservationconfirm" }
              ],
            },
            {
              label: "ประเมินความต้องการ", icon: faClipboardList,
              path: "/officersvlist",
              subMenu: [
                { label: "แผนการผลิต (ข้อมูลการสั่งผลิต)", path: "/vaccineestimateproductionlist" },
                { label: "งบจำหน่าย", path: "/vaccineestimatedistributionlist" },
                { label: "งบป้องกัน", path: "/vaccineestimatepreventionlist" },
              ],
            },
            {
              label: "ข้อมูลหลัก", icon: faDatabase, icon: faDatabase,
              subMenu: [
                { label: "ที่ตั้งคลังวัคซีน", path: "/masterwarehouse" },
                { label: "ข้อมูลวัคซีน", path: "/mastervaccine" },
                { label: "ประเภทปศุสัตว์", path: "/masterlivestocktype" },
                { label: "หน่วยงาน", path: "/masterdldoffice" },
                { label: "แบบสอบถาม", path: "/questionnaire-list" },
              ],
            },
            {
              label: "ระบบข้อมูลสารสนเทศ ", icon: faLineChart,
              path: "/officersvlist",
              subMenu: [
                //{ label: "รายงานแผนความต้องการวัคซีน", path: "/vaccinepreventiondemandplanreport" },
                { label: "Dashboard สถิติการเข้าใช้งานระบบ", path: "/systemusagedashboard" },
                { label: "Dashboard สถิติการเข้าถึงเว็บไซต์", path: "/websitevisitstatsdashboard" },
                { label: "Dashboard ยอดวัคซีนคงคลัง", path: "/vaccineinventorydashboard" },
                { label: "รายงานแผนความต้องการวัคซีน (งบป้องกัน)", path: "/vaccinepestimatepreventionreport" },
                { label: "รายงานแผนความต้องการวัคซีน (งบจำหน่าย)", path: "/vaccinepestimatedistributionreport" },
                { label: "รายงานการผลิตวัคซีน", path: "/vaccineproductionreport" },
                { label: "รายงานแผนการผลิตวัคซีน", path: "/vaccineproductionplanreport" },
                { label: "รายงานผลการส่งวัคซีนทดสอบ", path: "/vaccineqcresultreport" },
                { label: "รายงานการกระจายวัคซีน (งบป้องกัน)", path: "/vaccinepreventiondistributionreport" },
                { label: "รายงานการจำหน่ายวัคซีน (งบจำหน่าย)", path: "/vaccinesaleorderreport" },
                { label: "รายงานวัคซีนคงคลัง", path: "/vaccineinventoryreport" },
                { label: "รายงานวัคซีนคงคลัง (ตาม Lot การผลิต)", path: "/vaccineinventorywithlotreport" },
                { label: "รายงานวัคซีนคงคลัง (ย้อนหลัง)", path: "/vaccineinventorybydatereport" },
                { label: "รายงานการขอเบิกวัคซีน", path: "/vaccinerequisitionreport" },
                { label: "รายงานสรุปรายการสั่งจองวัคซีน", path: "/vaccinereservationsummaryreport" },
                { label: "รายงานการสั่งจองวัคซีน", path: "/vaccinereservationreport" },
                { label: "รายงานวัคซีนใกล้หมดอายุ", path: "/vaccineaboutexpirereport" },
                { label: "รายงานการขนส่งวัคซีน", path: "/vaccineshippingreport" },
                { label: "รายงานสรุปผลจากแบบสอบถาม", path: "/vaccineusagesatisfactionreport" },
                { label: "รายงานสรุปผลการเกิดโรคระบาด", path: "/animalepidemicreport" },
                { label: "รายงานสรุปผลการใช้วัคซีน", path: "/vaccineusageevaluatereport" },
                // { label: "รายงานวัคซีนคงคลังตามระดับคลัง", path: "/vaccineInventoryregionreport" },
                { label: "รายงานวัคซีนคงคลังตามระดับคลัง", path: "/vaccineinventorybywarehouselevelreport" },
                { label: "รายงานจำนวนปศุสัตว์แยกตามพื้นที่", path: "/livestockamountreport" },
                { label: "รายงานการแสดงความคิดเห็น", path: "/visitorcommentsreport" },
                { label: "รายงานการเข้าใช้งานระบบ", path: "/userloginlogreport" },
                { label: "รายงานการบันทึกข้อมูล (Audit Log)", path: "/auditlogreport" },
              ],
            },
          ]);
          break;          
        default:
          // fallback ถ้า OfficeType ไม่ตรงกับที่ระบุไว้
          setMenuItems([
            { label: "หน้าแรก", path: "/home", icon: faHome },
            { label: "จองวัคซีน", path: "/vaccinereservationlist", icon: faSyringe },
            { label: "จุดจำหน่ายวัคซีน", path: "/distributionpoint", icon: faWarehouse },
          ]);
      }
    }
  }, [profile]);


  const handleMenuClick = (path) => {
    // ควรใช้ navigate แทน window.location.href สำหรับ Single Page App
    if (path) navigate(path);
  };

  return (
    <Box ml={5}>
      <HStack
        spacing={2}
        justify="center"
        divider={<StackDivider borderColor="whiteAlpha.300" />}
      >
        {menuItems.map((item, index) =>
          item.subMenu ? (
            <Menu key={index} trigger="hover">
              <MenuButton
                as={Button}
                variant="ghost"
                color="white"
                h="70px"
                px={1} // ลด padding แนวนอน
                borderRadius="md"
                transition="all 0.2s ease-in-out"
                _hover={{ bg: "whiteAlpha.200", textDecoration: "none" }}
                _active={{ bg: "whiteAlpha.300" }}
                flex="1"
                minW="50px" 
                width="100px"
              >
                <VStack spacing={4}>
                  <FontAwesomeIcon icon={item.icon} size="lg" />
                  <Flex align="center">
                    <Text fontSize={labelFontSize} fontWeight="medium" whiteSpace="nowrap">
                      {item.label}
                    </Text>
                    <FontAwesomeIcon icon={faChevronDown} style={{ marginLeft: "4px" }} size="2xs"/>
                  </Flex>
                </VStack>
              </MenuButton>
              <MenuList minW="180px" maxH="70vh" overflowY="auto">
                {item.subMenu.map((subItem, subIndex) => (
                  <MenuItem
                    key={subIndex}
                    fontSize={subMenuFontSize}
                    onClick={() => handleMenuClick(subItem.path)}
                    _hover={{ bg: "#E6F0FA" }}
                    py={1.5}
                  >
                    {subItem.label}
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>
          ) : (
            <Button
              key={index}
              variant="ghost"
              color="white"
              h="70px"
              px={1} // ลด padding แนวนอน
              borderRadius="md"
              transition="all 0.2s ease-in-out"
              onClick={() => handleMenuClick(item.path)}
              _hover={{ bg: "whiteAlpha.200", textDecoration: "none" }}
                flex="1"
                minW="50px" 
                width="100px"
            >
              <VStack spacing={4}>
                <FontAwesomeIcon icon={item.icon} size="lg" />
                <Text fontSize={labelFontSize} fontWeight="medium" whiteSpace="nowrap">
                  {item.label}
                </Text>
              </VStack>
            </Button>
          )
        )}
      </HStack>
    </Box>
  );
};

export default TopMenu;